import { styled } from "theme/default/styled";
import { setFlexDFFDC } from "theme/setter/setFlexValues/setFlexDFFDC";

export const SUsersInfoPageLayoutContainer = styled.div`
  height: fit-content;

  ${setFlexDFFDC};
`;
